import { httpService } from '../httpService';
import { Profile } from '../../models/profile';
import { Employee } from '../../models/employee';
import {
  ProfilePreferences,
  ProfilePreferencesField,
  ProfilePreferencesResponse,
} from '../../models/preferences';

const PROFILE_API_URL = '/api/Profiles';

export const getProfile = async (): Promise<Profile> => {
  const response = await httpService.get<Profile>(PROFILE_API_URL);

  return response.data;
};

export const getMyTeam = async (): Promise<Employee[]> => {
  const response = await httpService.get<Employee[]>(`${PROFILE_API_URL}/team`);

  return response.data;
};

export const getPreferences = async (): Promise<ProfilePreferencesResponse> => {
  const response = await httpService.get<ProfilePreferencesResponse>(
    `${PROFILE_API_URL}/preferences`
  );

  return response.data;
};

interface PreferencesParams {
  activityView: number;
  defaultProjectId?: string;
  defaultTaskId?: string;
  exportDetailsShowContractType: boolean;
  exportDetailsShowProjectManager: boolean;
}
export const editPreferences = async (
  preference: ProfilePreferences
): Promise<void> => {
  const preferences: PreferencesParams = {
    activityView: preference.activityView,
    exportDetailsShowContractType: preference[ProfilePreferencesField.EXPORT_SHOW_CONTRACT_TYPE],
    exportDetailsShowProjectManager: preference[ProfilePreferencesField.EXPORT_SHOW_PROJECT_MANAGER],
  };

  const projectPreference = preference[ProfilePreferencesField.PROJECT];
  if (projectPreference) {
    preferences.defaultProjectId = projectPreference.id;
  }

  const taskPreference = preference[ProfilePreferencesField.TASK];
  if (taskPreference) {
    preferences.defaultTaskId = taskPreference.id;
  }

  await httpService.put(PROFILE_API_URL, preferences);
};
